import { apiConfig } from './apiConfig';

async function http(url, opts={}) {
  const res = await fetch(url, { ...opts, headers: { 'Accept':'application/json', ...(opts.headers||{}) } });
  let json=null; try{ json = await res.json(); }catch(e){}
  if(!res.ok || (json && json.success===false)) throw new Error((json && json.error && json.error.message) || 'HTTP '+res.status);
  return json;
}

export async function listActive() {
  try {
    const data = await http(`${apiConfig.publicationBase}/publications/active/list`);
    if(data && data.success) return data.data;
    return [];
  } catch(e){
    // graceful fallback
    return [];
  }
}

export default { listActive };
